// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface PublishVideoCompletion
 */
export interface PublishVideoCompletion {
    /**
     * 
     * @type {number}
     * @memberof PublishVideoCompletion
     */
    completion: number;
}

export function PublishVideoCompletionFromJSON(json: any): PublishVideoCompletion {
    return {
        'completion': json['completion'],
    };
}

export function PublishVideoCompletionToJSON(value?: PublishVideoCompletion): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'completion': value.completion,
    };
}


